const Cart = require('./Cart')

window.$cart = new Cart();

$dependencyManager.addDependencyCallback('gsap', () => {
  const SideCart = require('./sideCart');
  window.$sideCart = new SideCart();
})